module.exports = __webpack_public_path__ + "media/images/new_tab-951b67da7d10f47e3aab34d079e2e334.svg";